import { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  MagnifyingGlass, 
  ChartBar, 
  TrendUp, 
  Target,
  ShoppingCart,
  Check,
  ArrowLeft,
  Eye
} from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const products = [
  // Stage 1: التشخيص
  {
    id: 1,
    stage: 1,
    stageName: 'التشخيص',
    stageNameEn: 'Diagnosis',
    stageIcon: MagnifyingGlass,
    stageColor: '#2C3814',
    name: 'أداة التقييم الذاتي الشامل لجودة الطفولة المبكرة',
    nameEn: 'Early Childhood Quality Self-Assessment Framework',
    description:
      'أداة تشخيصية احترافية تساعد مراكز الطفولة المبكرة على تقييم جودة الأداء، تحديد الفجوات، وبناء أولويات التحسين وفق قراءة منظمة وشواهد قابلة للتحقق.',
    features: [
      '19 معياراً متخصصاً',
      'مؤشرات تفصيلية قابلة للتطبيق',
      'جدول حصر الفجوات والحلول',
      'ربط مباشر بين التشخيص وقرار الجاهزية',
    ],
    price: 1500,
    currency: 'ر.س',
    isFlagship: true,
    buyText: 'شراء الأداة',
    buyHref: '/store',
    previewText: 'معاينة جزء من الأداة',
    previewApiPath: '/api/preview/aafaq-self-assessment-tool',
  },
  {
    id: 2,
    stage: 1,
    stageName: 'التشخيص',
    stageNameEn: 'Diagnosis',
    stageIcon: MagnifyingGlass,
    stageColor: '#2C3814',
    name: 'استبيان الجودة الشامل',
    nameEn: 'Quality Survey Package',
    description: 'مجموعة استبيانات متخصصة لقياس رضا أولياء الأمور والموظفين وتقييم بيئة العمل',
    features: ['3 استبيانات متكاملة', 'تحليل إحصائي', 'مقارنة معيارية'],
    price: 800,
    currency: 'ر.س',
  },
  // Stage 2: التحليل
  {
    id: 3,
    stage: 2,
    stageName: 'التحليل',
    stageNameEn: 'Analysis',
    stageIcon: ChartBar,
    stageColor: '#3C4A20',
    name: 'تقرير التحليل المفصل',
    nameEn: 'Detailed Analysis Report',
    description: 'تقرير تحليلي شامل يقارن نتائج التقييم بالمعايير المرجعية ويحدد الفجوات والأولويات',
    features: ['تحليل الفجوات', 'مقارنة مرجعية', 'أولويات التحسين'],
    price: 2000,
    currency: 'ر.س',
  },
  {
    id: 4,
    stage: 2,
    stageName: 'التحليل',
    stageNameEn: 'Analysis',
    stageIcon: ChartBar,
    stageColor: '#3C4A20',
    name: 'لوحة مؤشرات الأداء',
    nameEn: 'Performance Dashboard',
    description: 'لوحة تحكم رقمية لمتابعة مؤشرات الأداء الرئيسية وقياس التقدم بشكل مستمر',
    features: ['15 مؤشر أداء', 'متابعة دورية', 'تنبيهات ذكية'],
    price: 1200,
    currency: 'ر.س',
  },
  // Stage 3: التحسين
  {
    id: 5,
    stage: 3,
    stageName: 'التحسين',
    stageNameEn: 'Improvement',
    stageIcon: TrendUp,
    stageColor: '#4A5D23',
    name: 'خطة التحسين المتكاملة',
    nameEn: 'Integrated Improvement Plan',
    description: 'خطة عمل مفصلة ومخصصة لمركزك تتضمن أهدافاً ذكية وجداول زمنية ومسؤوليات واضحة',
    features: ['أهداف SMART', 'جدول زمني', 'آلية متابعة'],
    price: 2500,
    currency: 'ر.س',
  },
  {
    id: 6,
    stage: 3,
    stageName: 'التحسين',
    stageNameEn: 'Improvement',
    stageIcon: TrendUp,
    stageColor: '#4A5D23',
    name: 'البرنامج التدريبي المتخصص',
    nameEn: 'Specialized Training Program',
    description: 'برنامج تدريبي شامل للكوادر يغطي جميع جوانب الجودة في الطفولة المبكرة',
    features: ['20 ساعة تدريبية', 'شهادات معتمدة', 'تطبيقات عملية'],
    price: 3500,
    currency: 'ر.س',
  },
  // Stage 4: الأثر
  {
    id: 7,
    stage: 4,
    stageName: 'الأثر',
    stageNameEn: 'Impact',
    stageIcon: Target,
    stageColor: '#5A6E33',
    name: 'شهادة الجاهزية للاعتماد',
    nameEn: 'Accreditation Readiness Certificate',
    description: 'شهادة معتمدة تثبت جاهزية مركزك للتقدم لبرامج الاعتماد الوطنية والدولية',
    features: ['تقييم شامل', 'شهادة رسمية', 'صلاحية سنة'],
    price: 4000,
    currency: 'ر.س',
  },
  {
    id: 8,
    stage: 4,
    stageName: 'الأثر',
    stageNameEn: 'Impact',
    stageIcon: Target,
    stageColor: '#5A6E33',
    name: 'تقرير الأثر النهائي',
    nameEn: 'Final Impact Report',
    description: 'تقرير شامل يوثق رحلة التحسين والإنجازات المحققة مع قياس الأثر على جميع المستويات',
    features: ['توثيق الإنجازات', 'قياس الأثر', 'توصيات مستقبلية'],
    price: 1800,
    currency: 'ر.س',
  },
];

const stages = [
  { id: 0, name: 'الكل', nameEn: 'All' },
  { id: 1, name: 'التشخيص', nameEn: 'Diagnosis', icon: MagnifyingGlass, color: '#2C3814' },
  { id: 2, name: 'التحليل', nameEn: 'Analysis', icon: ChartBar, color: '#3C4A20' },
  { id: 3, name: 'التحسين', nameEn: 'Improvement', icon: TrendUp, color: '#4A5D23' },
  { id: 4, name: 'الأثر', nameEn: 'Impact', icon: Target, color: '#5A6E33' },
];

const ProductsPage = () => {
  const [selectedStage, setSelectedStage] = useState(0);
  const [cart, setCart] = useState([]);

  const filteredProducts = selectedStage === 0 
    ? products 
    : products.filter(p => p.stage === selectedStage);

  const addToCart = (product) => {
    if (!cart.find(item => item.id === product.id)) {
      setCart([...cart, product]);
    }
  };

  const isInCart = (productId) => cart.some(item => item.id === productId);

  const totalPrice = cart.reduce((sum, item) => sum + item.price, 0);

  return (
    <main data-testid="products-page" className="pt-20 min-h-screen bg-[#FAFAF7]">
      {/* Hero Section */}
      <section className="py-16 bg-[#F3EFE9] relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#2C3814]/5 rounded-full blur-3xl" />
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <span className="inline-block px-4 py-2 bg-[#FAFAF7] text-[#3C4A20] text-sm font-medium rounded-full border border-[#D5D1C8] mb-6">
              منتجاتنا وخدماتنا
            </span>
            <h1 
              data-testid="products-title"
              className="text-4xl sm:text-5xl font-bold text-[#1A210D] font-['IBM_Plex_Sans_Arabic'] mb-6"
            >
              أدوات رحلة الاعتماد
            </h1>
            <p className="text-lg text-[#7A8A62] leading-relaxed">
              مجموعة متكاملة من المنتجات والأدوات لكل مرحلة من مراحل رحلتك نحو التميز
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stage Filter */}
      <section className="py-8 bg-[#FAFAF7] sticky top-20 z-30 border-b border-[#D5D1C8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {stages.map((stage) => (
              <button
                key={stage.id}
                data-testid={`stage-filter-${stage.id}`}
                onClick={() => setSelectedStage(stage.id)}
                className={`px-5 py-2.5 rounded-xl font-medium transition-all duration-300 flex items-center gap-2 ${
                  selectedStage === stage.id
                    ? 'bg-[#2C3814] text-[#FAFAF7] shadow-lg'
                    : 'bg-[#F3EFE9] text-[#3C4A20] hover:bg-[#E8E4DC]'
                }`}
              >
                {stage.icon && <stage.icon size={18} weight="duotone" />}
                <span>{stage.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product, index) => (
              <motion.div
                key={product.id}
                data-testid={`product-card-${product.id}`}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="bg-[#FAFAF7] rounded-3xl border border-[#D5D1C8] overflow-hidden hover:shadow-[0_12px_40px_rgba(44,56,20,0.1)] transition-all duration-300 hover:-translate-y-1 flex flex-col"
              >
                {/* Stage Badge */}
                <div 
                  className="px-6 py-3 flex items-center gap-2"
                  style={{ backgroundColor: `${product.stageColor}10` }}
                >
                  <product.stageIcon size={18} weight="duotone" style={{ color: product.stageColor }} />
                  <span className="text-sm font-medium" style={{ color: product.stageColor }}>
                    {product.stageName}
                  </span>
                  <span className="text-xs text-[#7A8A62]">• {product.stageNameEn}</span>
                </div>

                {/* Content */}
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-xl font-bold text-[#1A210D] font-['IBM_Plex_Sans_Arabic'] mb-2">
                    {product.name}
                  </h3>
                  <span className="text-xs text-[#7A8A62] block mb-3">{product.nameEn}</span>
                  <p className="text-[#3C4A20] text-sm leading-relaxed mb-4 flex-1">
                    {product.description}
                  </p>

                  {/* Features */}
                  <ul className="space-y-2 mb-6">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-sm text-[#1A210D]">
                        {product.isFlagship ? (
                          <span className="text-[#4A5D23] font-bold shrink-0" aria-hidden="true">✔</span>
                        ) : (
                          <Check size={16} weight="bold" className="text-[#4A5D23]" />
                        )}
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* Price & CTA */}
                  <div className="pt-4 border-t border-[#D5D1C8]">
                    {product.isFlagship ? (
                      <div className="space-y-3">
                        <div className="flex items-center justify-between">
                          <div>
                            <span className="text-2xl font-bold text-[#2C3814]">
                              {product.price.toLocaleString()}
                            </span>
                            <span className="text-sm text-[#7A8A62] mr-1">{product.currency}</span>
                          </div>
                          <Link to={product.buyHref} data-testid={`buy-flagship-${product.id}`}>
                            <Button className="rounded-xl px-5 py-2.5 bg-[#2C3814] hover:bg-[#3C4A20] text-[#FAFAF7] transition-all flex items-center gap-2">
                              <ShoppingCart size={18} />
                              {product.buyText}
                            </Button>
                          </Link>
                        </div>
                        <a
                          href={`${process.env.REACT_APP_BACKEND_URL}${product.previewApiPath}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid={`preview-flagship-${product.id}`}
                          className="inline-flex items-center gap-1.5 text-sm text-[#4A5D23] hover:text-[#2C3814] underline decoration-dotted underline-offset-4 transition-colors"
                        >
                          <Eye size={16} />
                          {product.previewText}
                        </a>
                      </div>
                    ) : (
                      <div className="flex items-center justify-between">
                        <div>
                          <span className="text-2xl font-bold text-[#2C3814]">{product.price.toLocaleString()}</span>
                          <span className="text-sm text-[#7A8A62] mr-1">{product.currency}</span>
                        </div>
                        <Button
                          data-testid={`add-to-cart-${product.id}`}
                          onClick={() => addToCart(product)}
                          disabled={isInCart(product.id)}
                          className={`rounded-xl px-5 py-2.5 transition-all ${
                            isInCart(product.id)
                              ? 'bg-[#4A5D23] text-[#FAFAF7]'
                              : 'bg-[#2C3814] hover:bg-[#3C4A20] text-[#FAFAF7]'
                          }`}
                        >
                          {isInCart(product.id) ? (
                            <span className="flex items-center gap-2">
                              <Check size={18} />
                              تمت الإضافة
                            </span>
                          ) : (
                            <span className="flex items-center gap-2">
                              <ShoppingCart size={18} />
                              إضافة
                            </span>
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Floating Cart */}
      {cart.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:w-96 bg-[#2C3814] rounded-2xl p-4 shadow-[0_12px_40px_rgba(44,56,20,0.3)] z-40"
        >
          <div className="flex items-center justify-between text-[#FAFAF7] mb-3">
            <div className="flex items-center gap-2">
              <ShoppingCart size={20} />
              <span className="font-medium">{cart.length} منتج</span>
            </div>
            <div>
              <span className="text-xl font-bold">{totalPrice.toLocaleString()}</span>
              <span className="text-sm mr-1">ر.س</span>
            </div>
          </div>
          <Link 
            to="/checkout" 
            state={{ cartItems: cart.map(item => ({ 
              id: item.id, 
              name: item.name, 
              nameEn: item.nameEn,
              price: item.price, 
              stageName: item.stageName,
              stageColor: item.stageColor 
            })) }}
          >
            <Button 
              data-testid="go-to-checkout"
              className="w-full bg-[#FAFAF7] text-[#2C3814] hover:bg-[#F3EFE9] rounded-xl py-3 font-medium"
            >
              <span>إتمام الطلب</span>
              <ArrowLeft size={18} className="mr-2 rtl-flip" />
            </Button>
          </Link>
        </motion.div>
      )}
    </main>
  );
};

export default ProductsPage;
